import React, { useState, useEffect } from 'react';

// hola

const DiscountCodeForm = (props) => {
    
    const handleSubmit = e => {
        e.preventDefault();
    };

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3">        
                    <div class="input-group is-invalid">
                        <div class="custom-file">
                            <input 
                                className="form form-control"
                                id='validatedInputGroupCustomFile'
                                type="text" 
                                name="code" 
                                value={props.formValues.code}
                                onChange={props.handleChange}
                                placeholder="Codigo"
                                disabled={props.isLoadedDiscountCode}
                            />
                        </div>
                        <div class="input-group-append">
                            <button class="btn btn-primary" disabled={props.isLoadedDiscountCode} onClick={() => props.handleClick()} type="button">{props.isLoadedDiscountCode ? "Aplicando" : "Aplicar"}</button>
                        </div>
                    </div>

                    {!props.errorValues && (
                        <div className="col-md-12 mt-4">
                            <div className="alert alert-danger" role="alert">
                                <b>Debes de completar todos los campos requeridos</b>
                            </div>
                        </div>
                    )}
                </div>
            </form>
        </React.Fragment>
    );
}


export default DiscountCodeForm;

